export enum UsersTableAccessors {
  Email = 'email',
  Name = 'name',
  Role = 'role',
  User = 'user',
}
